// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid_zoMr1 {
  display: grid;
  grid-template-columns: 12% 9% 28% 28% 22%;
  column-gap: 3px;
  row-gap: var(--size-padMedium);
  width: 100%;
  align-items: center;
  justify-items: center;
  min-height: 40px;
  padding: var(--size-padMedium);
}

.grid_zoMr1 {
  /* background-color: var(--color-operatingHoursRowOdd, white); */
  overflow: visible;
}

.grid_zoMr1:nth-child(even) {
  /* background-color: var(--color-operatingHoursRowEven, --color-base025); */
}

.gridFirstColumn_b2h1M {
  justify-self: start;
}

.container_plIPq {
  width: 100%;
  overflow: visible;
}

.body_AeZ8t {
  overflow: visible;
}

.thead_E28DM {
  background: #f3f5f6;
}

.closed_jmcpe {
  grid-column: span 2;
}

.remove_RNMcz {
  grid-area: one;
}

.add_WeEHH {
  grid-area: two;
}

.copy_gevTt {
  grid-area: three;
}

.toolbar_TSMQt {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas: "one two three";
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-operating-hours/lib/WeeklyHoursEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yCAAyC;EACzC,eAAe;EACf,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gEAAgE;EAChE,iBAAiB;AACnB;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,oCAAoC;EACpC,WAAW;AACb","sourcesContent":[".grid {\n  display: grid;\n  grid-template-columns: 12% 9% 28% 28% 22%;\n  column-gap: 3px;\n  row-gap: var(--size-padMedium);\n  width: 100%;\n  align-items: center;\n  justify-items: center;\n  min-height: 40px;\n  padding: var(--size-padMedium);\n}\n\n.grid {\n  /* background-color: var(--color-operatingHoursRowOdd, white); */\n  overflow: visible;\n}\n\n.grid:nth-child(even) {\n  /* background-color: var(--color-operatingHoursRowEven, --color-base025); */\n}\n\n.gridFirstColumn {\n  justify-self: start;\n}\n\n.container {\n  width: 100%;\n  overflow: visible;\n}\n\n.body {\n  overflow: visible;\n}\n\n.thead {\n  background: #f3f5f6;\n}\n\n.closed {\n  grid-column: span 2;\n}\n\n.remove {\n  grid-area: one;\n}\n\n.add {\n  grid-area: two;\n}\n\n.copy {\n  grid-area: three;\n}\n\n.toolbar {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-areas: \"one two three\";\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_zoMr1`,
	"gridFirstColumn": `gridFirstColumn_b2h1M`,
	"container": `container_plIPq`,
	"body": `body_AeZ8t`,
	"thead": `thead_E28DM`,
	"closed": `closed_jmcpe`,
	"remove": `remove_RNMcz`,
	"add": `add_WeEHH`,
	"copy": `copy_gevTt`,
	"toolbar": `toolbar_TSMQt`
};
export default ___CSS_LOADER_EXPORT___;
